import { callBreadcrumbAPI } from './callBreadcrumbAPI'
import { fetchTicketDocs } from './fetchTicketDocs'
import { fetchPermissions } from './fetchPermissions'
import { fetchBusinessRules } from './fetchBusinessRules'
import { postDocument } from './postDocument'
import { fetchFoldersJsonData } from './fetchFoldersJsonData'
import { fetchTicketDetail } from './fetchTicketDetail'
import { fetchTicketLogs } from './fetchTicketLogs'
import { fetchFolderDocuments } from './fetchFolderDocuments'
import { fetchMatchingTickets } from './fetchMatchingTickets'
import { fetchAllActiveDocsInDivision } from './fetchAllActiveDocsInDivision'
import { postDivisionSupervisor } from './postDivisionSupervisor'
import { fetchArchiveDocuments } from './fetchArchiveDocuments'
import { sendSumoLog } from './sumoLogger'
import { fetchTicketNotifList } from './fetchTicketNotifList'
import { fetchContactList } from './fetchContactList'
import { fetchStandbyInspectorsList } from './fetchStandbyInspectorsList'
import { fetchRegCodesList } from './fetchRegCodesList'
import { postTicketNotif } from './postTicketNotif'
import { putTicketNotif } from './putTicketNotif'
import { deleteTicketNotif } from './deleteTicketNotif'
import { fetchTicketNotifDetails } from './fetchTicketNotifDetails'
import { fetchContact } from './fetchContact'
import { postNotifUser } from './postNotifUser'
import { putNotifUser } from './putNotifUser'
import { deleteNotifUser } from './deleteNotifUser'
import { fetchStandbyInspector } from './fetchStandbyInspector'
import { postStandbyInspector } from './postStandbyInspector'
import { putStandbyInspector } from './putStandbyInspector'
import { deleteStandbyInspector } from './deleteStandbyInspector'
import { uploadPhoto } from './uploadPhoto'

export {
    callBreadcrumbAPI,
    fetchTicketDocs,
    postDocument,
    fetchPermissions,
    fetchBusinessRules,
    fetchFoldersJsonData,
    fetchTicketDetail,
    fetchTicketLogs,
    fetchFolderDocuments,
    fetchMatchingTickets,
    fetchAllActiveDocsInDivision,
    postDivisionSupervisor,
    fetchArchiveDocuments,
    sendSumoLog,
    fetchTicketNotifList,
    fetchContactList,
    fetchStandbyInspectorsList,
    fetchRegCodesList,
    postTicketNotif,
    putTicketNotif,
    deleteTicketNotif,
    fetchTicketNotifDetails,
    fetchContact,
    postNotifUser,
    putNotifUser,
    deleteNotifUser,
    fetchStandbyInspector,
    postStandbyInspector,
    putStandbyInspector,
    deleteStandbyInspector,
    uploadPhoto
}

const API = {
  fetchStandbyInspectorsList,
};
export default API;